<template>
    <li class="list-group-item d-flex flex-wrap flex-direction-row justify-content-start">
        <div class="d-flex align-items-baseline" style="width:100%">
            <button v-if="canClear" @click="showModal" class="btn btn-sm btn-outline-secondary mr-3 py-0 px-1">Clear</button>
            <span class="badge badge-secondary badge-pill">{{ student.infractions.length }}</span>
            <router-link :to="{name: 'studentHistory', params: {id: student.id}}" class="ml-3 mb-3 text-dark">
                {{ student.name }}
            </router-link>
            <a class="text-muted no-underline ml-auto" data-toggle="collapse" v-bind:href="'#collapsedInfraction' + student.id" aria-expanded="open" v-bind:aria-controls="'collapsedInfraction' + student.id" @click="open = !open">
                {{open ? '[-]' : '[+]'}}
            </a>
        </div>
        <div class="collapse" style="width:100%" v-bind:id="'collapsedInfraction' + student.id">
            <p v-for="infraction in student.infractions" :key="infraction.id" class="d-flex flex-direction-row justify-content-start text-left">{{ infraction }}
            <span v-if="canAssign" class="text-danger text-center small clickable ml-auto py-0 px-1" role="button" @click="assignDetention(student.id, student.name, infraction)">Assign detention</span>
            </p>
        </div>
    </li>
</template>


<script>
import Firebase from 'firebase/app'
import { db } from '@/main.js'

export default {
    name: "Infraction",
    props: ['student', 'index'],
    data () {
        return {
            open: false
        }
    },
    methods: {
        assignDetention: function (studentId, studentName, infraction) {
            // update detention counter on student documnet
            var studentRef = db.collection('students').doc(studentId);
            studentRef.update({
                detentions: Firebase.firestore.FieldValue.arrayUnion(
                    {
                        "descr": infraction,
                        "type": "Morning"
                    }
                ),
                detentionCounter: Firebase.firestore.FieldValue.increment(1),
                })
            this.$toasted.show(studentName + ' assigned a detention.')     
        },
        showModal: function() {
            this.$emit('modal', [this.student])
        },
    },
    computed: {
        canAssign: function() {
            return this.$root.sharedState.accessLevel >= 4
        },
        canClear: function() {
            return this.$root.sharedState.accessLevel >= 3
        }
    }
}
</script>
